import { IClassDTOOut } from '../../interfaces/groups/class.interface';

export class GetAllClasses {
    public static readonly type = '[Classes] get all';
    constructor(public forceCall?: boolean) {}
}

export class GetClassById {
    public static readonly type = '[Class] get one';
    constructor(public id: number) {}
}

export class CreateNewClass {
    public static readonly type = '[Class] create';
    constructor(public newClass: IClassDTOOut) {}
}

export class PatchClass {
    public static readonly type = '[Class] patch';
    constructor(public schoolClass: IClassDTOOut) {}
}

export class DeleteClass {
    public static readonly type = '[Class] delete';
    constructor(public classId: number) {}
}

export class EnableClass {
    public static readonly type = '[Class] enable';
    constructor(public classId: number) {}
}

export class DisableClass {
    public static readonly type = '[Class] disable';
    constructor(public classId: number) {}
}

export class DeleteClassToEdit {
    public static readonly type = '[Class to edit] delete';
}

export class DeleteCachedClasses {
    public static readonly type = '[Class] delete cached list';
}
